type CostVersusOutputMeasures =
  | 'cost'
  | 'daily_burn'
  | 'cost_per_point'
  | 'cost_per_task'
  | 'committed_points'
  | 'completed_points'
  | 'committed_tasks'
  | 'completed_tasks';

type AllocationOfCostsMeasures = 'assignee' | 'type' | 'label';

type State = {
  view: View;
  chart: Charts;
  team: string | null;
  board: string | null;
  startDate: Date | null;
  endDate: Date | null;
  filters: Filters;
  table: {
    selectedYear: number | null;
    searchTerm: string | undefined;
  };
};

type Filters = {
  costVersusOutput: {
    selectedChartType: ChartType;
    selectedMeasures: CostVersusOutputMeasures[];
    selectedTrendLines: CostVersusOutputMeasures[];
  };
  allocationOfCosts: {
    selectedChartType: ChartType;
    selectedMeasure: AllocationOfCostsMeasures;
    selectedOptions: string[];
    selectedTrendLines: string[];
  };
  costByInitiative: {
    selectedChartType: ChartType;
    selectedInitiativeIds: string[];
    selectedTrendLines: string[];
  };
};

enum View {
  Charts = 'charts',
  Table = 'table',
}

enum Charts {
  CostVersusOutput = 'costVersusOutput',
  AllocationOfCosts = 'allocationOfCosts',
  CostByInitiative = 'costByInitiative',
}

enum ChartType {
  Line = 'line',
  Bar = 'bar',
}

export { Charts, ChartType, View };
export type { AllocationOfCostsMeasures, CostVersusOutputMeasures, Filters, State };
